import { useState } from 'preact/hooks'

const getInitials = (name) => {
  return name.split(' ').map(n => n[0]).join('').toUpperCase()
}

const getSizeClasses = (size) => {
  switch (size) {
    case 'xs':
      return 'w-6 h-6 text-xs'
    case 'sm':
      return 'w-8 h-8 text-xs'
    case 'md':
      return 'w-12 h-12 text-sm'
    case 'lg':
      return 'w-16 h-16 text-base'
    default:
      return 'w-12 h-12 text-sm'
  }
}

export function SpeakerImage({ speaker, size = 'md' }) {
  const [imageError, setImageError] = useState(false)
  const sizeClasses = getSizeClasses(size)
  
  if (imageError || !speaker.imageUrl) {
    return (
      <div className={`${sizeClasses} rounded-full bg-gradient-to-r from-editions-purple to-editions-purple-light flex items-center justify-center text-white font-semibold border-2 border-editions-purple/30 flex-shrink-0`}>
        {getInitials(speaker.name)}
      </div>
    )
  }
  
  return (
    <img
      className={`${sizeClasses} rounded-full object-cover border-2 border-editions-purple/30 flex-shrink-0`}
      src={speaker.imageUrl}
      alt={speaker.name}
      onError={() => setImageError(true)}
      loading="lazy"
    />
  )
} 